import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Spinner } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { getDiscrepancyImages } from 'services/stock-location/discrepancyService';

const DiscrepancyImageGalary = ({ isShow, data, handleClose }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const mapToGalleryItems = arr =>
    (arr || [])
      .map(x => ({
        original: x || x.url,
        thumbnail: x || x.url,
        description: '' || ''
      }))
      .filter(it => !!it.original);

  useEffect(() => {
    if (!isShow) return;

    const grn = data?.grn ?? data?.id;
    if (!grn) {
      setItems([]);
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const rs = await getDiscrepancyImages(grn);
        const list = rs?.data?.data || [];
        const mapped = mapToGalleryItems(list);
        if (!cancelled) setItems(mapped);
      } catch (e) {
        console.error('Error fetching images:', e);
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isShow, data?.grn, data?.id]);

  return (
    <Modal
      show={isShow}
      onHide={handleClose}
      size="lg"
      dialogClassName="modal-90w"
    >
      <Modal.Header closeButton>
        <Modal.Title>Images {data?.wpoRef}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '80vh', overflow: 'auto' }}>
        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" />
          </div>
        ) : items.length > 0 ? (
          <ImageGallery items={items} showPlayButton={false} />
        ) : (
          <p className="text-muted m-0">No images available</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DiscrepancyImageGalary.propTypes = {
  isShow: PropTypes.bool,
  data: PropTypes.shape({
    grn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    wpoRef: PropTypes.oneOfType([PropTypes.string])
  }),
  handleClose: PropTypes.func
};

export default DiscrepancyImageGalary;
